import React from "react";
import HeaderProfilePopupContent from "./headerProfilePopupContent";
import useOutsideClick from "../../../hooks/useOutsideClick";
import { getImageSrc } from "../../../utilites/util";
import "./scss/style.scss";
import { useSelector } from "react-redux";
import { AppState } from "../../../app/store/rootReducers";

type Props = {
  item: any;
  hideSubmenu: () => any;
};

const HeaderProfilePopup = ({ item, hideSubmenu }: Props) => {
  const user = useSelector((state: AppState) => state.session.user);

  const profileDetailsRef = React.createRef<HTMLDetailsElement>();
  useOutsideClick(profileDetailsRef);

  return (
    <div className="yettel-profile-menu">
      <details ref={profileDetailsRef} data-popover="down">
        <summary className="d-block pe-1 pt-1 p-0" key={item.id}>
          <div className="ytl-icon-container"></div>
          <img className="icon" alt={item.img.title} src={user.avatarUrl ?? getImageSrc("", item.img.title, 'png')}/>
        </summary>
        <div className="ytl-popover-menu">
          <HeaderProfilePopupContent item={item} hideSubmenu={hideSubmenu}/>
        </div>
      </details>
    </div>
  );
};

export default HeaderProfilePopup;
